import sofatime from './sofatime';
//import './sofatime.css';

window.addEventListener('load', function () {
  console.log('sofatime.js loaded!');
  sofatime();
})
